import React, { FC } from 'react';
import css from './event-item.module.css';
import { Link } from 'react-router-dom';
import { route } from '../../../../../services/utils';
import { useParams } from 'react-router';
import { AnimalEventStatus } from '../../../../../enums/animal-event-status';
import { AnimalEvent } from '../../../../../interfaces/animal-event';
import { LIVESTOCK_ANIMALS_EVENTS } from '../../../../../router/routes';
import { FormMode } from '../../../../../enums/form-mode';

interface EventItemProps {
  name: string;
  count: number;
  status: string;
  event: AnimalEvent;
  type: string;
}

const EventItem: FC<EventItemProps> = ({
  name,
  count,
  status,
  event,
  type,
}) => {
  const { farmId } = useParams<{ farmId: string }>();
  const getEventRoute = () => {
    return route(LIVESTOCK_ANIMALS_EVENTS + '?to=events', {
      farmId,
      animalType: event.type,
      id: event.id,
      mode: FormMode.view,
    });
  };

  const getStatusClass = () => {
    if (status === AnimalEventStatus.COMPLETE) return css['blueBackground'];
    else if (status === AnimalEventStatus.FAILED) return css['redBackground'];
    else return css['whiteBackground'];
  };
  return (
    <>
      <Link
        to={getEventRoute()}
        className={`${css['eventItem']} ${getStatusClass()}  ${type}`}
      >
        <span>{name}</span>
        <span>{count}</span>
      </Link>
    </>
  );
};

export default EventItem;
